<template>
  <b-card no-body class="mb-4 p-2 border-0 shadow">
    <b-card-header header-tag="header" class="p-0 border-0" role="tab">
      <h5 class="p-2">
        <i class="fa fa-sitemap" />
        ÁRBOL DE UBICACIONES
      </h5>
    </b-card-header>
    <b-card-body class="py-3 px-0">
      <b-row>
        <b-col sm="5">
          <b-form-group>
            <b-input-group>
              <b-form-input
                name="nombre"
                type="text"
                placeholder="Buscar..."
                v-model="filterText"
                class="text-uppercase"
              />
              <b-input-group-append>
                <b-button @click="limpiarFiltro" class="btn btn-default">
                  <i class="fa fa-eraser fa-lg" />
                  <span class="d-none d-md-inline-block"> Limpiar</span>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

         <b-col sm="3">
          <el-select
            id="estado"
            name="estado"
            v-model="filtro.active"
            placeholder="Filtrar por estado"
            size="sm"
            class="ml-1 d-block d-md-inline-block mt-2 mb-4 mt-sm-0"
            @change="filterTree"
            clearable
          >
            <el-option
              v-for="option in statusOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </b-col>

        <b-col sm="4" class="text-right">
          <b-button
            variant="primary"
            @click="createRootLocation"
            v-if="validarPermisoComponente('empresa-editar-ubicaciones')"
          >
            Crear ubicación Raiz
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col> </b-col>
      </b-row>
    </b-card-body>

    <el-tree
      class="filter-tree"
      :data="arbolUbicaciones"
      default-expand-all
      :filter-node-method="filterNode"
      ref="tree"
      node-key="id"
      draggable
      :allow-drag="allowDrag"
      :allow-drop="allowDrop"
      @node-drop="handleDrop"
      @node-drag-start="startAutoScroll"
      @node-drag-end="stopAutoScroll"
    >
      <span   class="custom-tree-node" slot-scope="{ node }">
        <span class="m-0 p-0 d-inline-flex align-items-center">
          <b-badge :style="{ background: node.data.location_level ? node.data.location_level.color : '#cccccc'}" :class="{'inactive-node': node.data.active === 0 || node.data.active === false}">{{ node.data.label }}</b-badge>


          <!-- País asignado directamente -->
          <el-tooltip
            v-if="node.data.company_country && node.data.company_country.country"
            :content="node.data.company_country.country.name"
            placement="top"
          >
            <span class="ml-2 tree-country-info" :class="{'inactive-node': node.data.active === 0 || node.data.active === false}">
              <img
                :src="`https://flagsapi.com/${node.data.company_country.country.code.toUpperCase()}/flat/64.png`"
                class="mr-1 flag-img-tree"
              >
              <span class="tree-country-acronym">{{ node.data.company_country.country.code }}</span>
            </span>
          </el-tooltip>

          <!-- País heredado (padre) -->
          <el-tooltip
            v-else-if="node.data.parent_location && typeof node.data.parent_location === 'object' && node.data.parent_location.company_country && node.data.parent_location.company_country.country"
            :content="node.data.parent_location.company_country.country.name"
            placement="top"
          >
            <span class="ml-2 tree-country-info" :class="{'inactive-node': node.data.active === 0 || node.data.active === false}">
              <img
                :src="`https://flagsapi.com/${node.data.parent_location.company_country.country.code.toUpperCase()}/flat/64.png`"
                class="mr-1 flag-img-tree"
              >
              <span class="tree-country-acronym">{{ node.data.parent_location.company_country.country.code }}</span>
            </span>
          </el-tooltip>

          <!-- Sin país (icono placeholder) -->
          <span v-else-if="!node.data.slq_location_id" class="ml-2 text-muted" :class="{'inactive-node': node.data.active === 0 || node.data.active === false}">
             <i class="fa fa-globe"></i>
          </span>

        </span>

        <!-- Botones de acción (se muestran solo en hover) -->
        <span class="action-buttons">
          <el-tooltip v-if="validarPermisoComponente('empresa-editar-ubicaciones') && (node.data.active === 1 || node.data.active === true)" content="Editar" placement="bottom" effect="light">
            <el-button
              type="text"
              size="medium"
              class="text-primary"
              @click="editarUbicacion(node.data)"
            >
              <i class="fa fa-edit fa-edit-tree ml-2 mr-1" />
            </el-button>
          </el-tooltip>

          <el-tooltip v-if="validarPermisoComponente('empresa-editar-ubicaciones') && (node.data.active === 1 || node.data.active === true)" content="Crear ubicación" placement="bottom" effect="light">
            <el-button
              type="text"
              size="medium"
              class="text-success"
              @click="createChildLocation(node.data)"
            >
              <i class="fa fa-plus-circle fa-plus-tree mr-1" />
           </el-button>
          </el-tooltip>

          <el-tooltip v-if="validarPermisoComponente('empresa-editar-ubicaciones')" :content="(node.data.active === 1 || node.data.active === true) ? 'Inactivar' : 'Activar'" placement="bottom" effect="light">
            <el-button
              type="text"
              size="medium"
              :class="(node.data.active === 1 || node.data.active === true) ? 'text-danger' : 'text-success'"
              @click="deleteLocation(node.data)"
            >
              <i :class="(node.data.active === 1 || node.data.active === true) ? 'fa fa-trash mr-1' : 'fa fa-check mr-1'" />
            </el-button>
          </el-tooltip>
        </span>
      </span>
    </el-tree>

    <!-- Modal de Actualización de Ubicación -->

    <b-modal
      v-model="modal_ubicaciones.ver"
      title="Actualizar ubicación"
      hide-footer
      size="xl"
      static
      centered
      @shown="focusUpdateInput"
    >
      <form @submit.prevent="validateFormUpdateLocation" data-vv-scope="updateLocation">
        <b-row class="mt-4">
          <!-- Solo nombre y país son editables - nivel y padre se cambian con drag and drop -->
          <b-col sm="6">
            <b-form-group>
              <label for="descripcion-update">Descripción Ubicación <span class="text-danger">*</span></label>
              <b-form-input
                ref="descripcionUpdateInput"
                id="descripcion-update"
                size="sm"
                type="text"
                name="descripcion"
                class="text-uppercase"
                v-model="selectedUbicacion.description"
                data-vv-as=" "
                v-validate="'required'"
              >
              </b-form-input>
              <span class="text-danger span-error small">
                {{ errors.first("updateLocation.descripcion") }}
              </span>
            </b-form-group>
          </b-col>

          <!-- Asignar País -->
          <b-col sm="6">
            <b-form-group>
              <label for="company_country_id">Asignar País</label><br />
              <el-select id="company_country_id" name="company_country_id" v-model="selectedUbicacion.company_country_id" data-vv-as=" " size="sm" clearable class="select-with-flag">
                <template slot="prefix" v-if="selectedCountry">
                    <div class="flag-prefix-container">
                        <img
                          :src="`https://flagsapi.com/${selectedCountry.country.code.toUpperCase()}/flat/64.png`"
                          class="flag-img-select"
                        >
                    </div>
                </template>
                <el-option
                  v-for="countryCompany in validCountriesCompany"
                  :label="`${countryCompany.country.name} - [${countryCompany.country.code}]`"
                  :value="countryCompany.id"
                  :key="countryCompany.id"
                >
                    <div class="d-flex align-items-center">
                        <img
                          :src="`https://flagsapi.com/${countryCompany.country.code.toUpperCase()}/flat/64.png`"
                          class="mr-2 flag-img-option"
                        >
                        <span>{{ countryCompany.country.name }} - [{{ countryCompany.country.code }}]</span>
                    </div>
                </el-option>
              </el-select>
            </b-form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-col>
            <b-button
              @click="validateFormUpdateLocation"
              variant="primary"
              class="btn btn-primary float-right"
            >
              Guardar
            </b-button>
            <b-button class="btn btn-default float-right mr-2" @click="cancel()">
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </form>
    </b-modal>

    <!-- Fin modal de Actualización de Ubicación -->

    <modal-ubicacion />
  </b-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { validarPermisoComponente } from "@/plugins/acl";
import modalUbicacion from "./modal";

export default {
  name: "ubicaciones-empresa",
  components: {
    modalUbicacion,
  },

  async mounted() {
    this.setCountriesOfCompany([]);
    await this.listarNivelActivos();
  },

  data() {
    return {
      filterText: "",

      searchVal: "",
      filtro: {
        active: null
      },
      ubicacion: "",
      newChild: {},
      validarPermisoComponente: validarPermisoComponente,
      enterprise_id: null,
      locations: [],
      levelSelected: { level: null, id: null },
      level: null,
      disabled: false,
      country_id: null,
      group_id: null,
      business_id: null,
       statusOptions: [
          {value: 1, label: 'Activo'},
          {value: 0, label: 'Inactivo'}
      ],
      // Configuración del auto-scroll durante drag and drop
      DRAG_SCROLL_CONFIG: {
        speed: 20,       // Píxeles a desplazar por ciclo
        edgeSize: 40,    // Zona de activación desde el borde (px)
        intervalMs: 50   // Intervalo entre ciclos de scroll (ms)
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter({ text: val, active: this.filtro.active });
    },
    'filtro.active': {
      handler: function (val) {
        this.setFiltroActive(val);
      },
      immediate: true
    },
    arbolUbicaciones: {
      handler: function () {
        this.$nextTick(() => {
          if (this.$refs.tree) {
            this.$refs.tree.filter({ text: this.filterText, active: this.filtro.active });
          }
        });
      },
      deep: true
    },
    country_id: {
      handler: async function (val) {
        if (val) {
          await this.getCountryByIdAndCompanyId({
            country_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setEnterprises([]);
          this.setGroups([]);
          this.setBusinesses([]);
          this.setSubBusinesses([]);
          this.enterprise_id = null;
          this.group_id = null;
          this.business_id = null;
        }
      },
      deep: true,
    },
    enterprise_id: {
      handler: async function (val) {
        if (val) {
          await this.getEnterpriseByIdAndCompanyId({
            enterprise_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setGroups([]);
          this.setBusinesses([]);
          this.setSubBusinesses([]);
          this.group_id = null;
          this.business_id = null;
        }
      },
      deep: true,
    },
    group_id: {
      handler: async function (val) {
        if (val) {
          await this.getGroupByIdAndCompanyId({
            group_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setBusinesses([]);
          this.setSubBusinesses([]);
          this.business_id = null;
        }
      },
      deep: true,
    },
    business_id: {
      handler: async function (val) {
        if (val) {
          await this.getBusinessByIdAndCompanyId({
            business_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setSubBusinesses([]);
          this.selectedUbicacion.slq_business_sub_business_id = null;
        }
      },
      deep: true,
    },

    selectedUbicacion: {
      handler: function(val){
        if(val && val.id && !val.parent){
          this.selectedUbicacion.slq_location_id = null;
        }
      },
      deep: true,
    },
  },

  methods: {
    async filterTree() {
       this.$store.commit("dashboard/load", true, { root: true });
       await this.arbolUbicacionesEmpresa({ all: 1 });
       this.$refs.tree.filter({ text: this.filterText, active: this.filtro.active });
       this.$store.commit("dashboard/load", false, { root: true });
    },
    filterNode(value, data) {
      if (!value) return true;

      const filterText = (value.text || '').toLowerCase();
      const filterActive = value.active;

      // Filtro de texto
      const matchesText = !filterText || data.label.toLowerCase().indexOf(filterText) !== -1;

      // Filtro de estado
      let matchesActive = true;
      if (filterActive !== null && filterActive !== undefined && filterActive !== '') {
         matchesActive = data.active == filterActive;
      }

      return matchesText && matchesActive;
    },

    async deleteLocation(ubicacion) {
      const esActiva = ubicacion.active === 1 || ubicacion.active === true;
      const nuevoEstado = esActiva ? 0 : 1;
      const accion = esActiva ? 'inactivar' : 'activar';
      const nombreUbicacion = ubicacion.label || ubicacion.description;

      var self = this;

      this.$alertConfirmation({
        icon: 'question',
        title: esActiva ? 'Inactivar ubicación' : 'Activar ubicación',
        text: `¿Está seguro de ${accion} la ubicación "${nombreUbicacion}"?`,
        showConfirmButton: true,
        showCancelButton: true,
        titleBtnConfirm: `Sí, ${accion}`,
        titleBtnCancel: 'Cancelar',
        onConfirm: async function() {
          await self.inactiveLocation({
            id: ubicacion.id,
            status: nuevoEstado,
            locationName: nombreUbicacion
          });
        }
      });
    },

    async createChildLocation(ubicacion) {
      if (!this.nivelesActivos || (!this.nivelesActivos.data && !Array.isArray(this.nivelesActivos))) {
        this.$alertError('No se han cargado los niveles de ubicación. Por favor, recargue la página.');
        return;
      }

      await this.listarNivelActivos();

      // Calcular el nivel hijo usando el array de niveles activos (location_level no viene en el endpoint)
      const niveles = this.nivelesActivos.data || this.nivelesActivos;
      const nivelPadreObj = niveles.find(n => n.id === ubicacion.slq_locations_level_id);
      const nivelHijo = nivelPadreObj ? Number(nivelPadreObj.level) + 1 : 1;


      // Buscar el nivel (convertir a Number para comparación segura)
      let nivelEncontrado = niveles.find(n => Number(n.level) === nivelHijo);

      // Si el nivel no existe, crearlo automáticamente
      if (!nivelEncontrado) {
        try {
          await this.crearNivelAutomatico({
            level: nivelHijo,
            description: 'Nivel ' + nivelHijo,
            slq_company_id: this.$route.params.id,
            active: true,
            color: '#FFFFFF'
          });

          // Recargar niveles para obtener el nuevo nivel creado
          await this.listarNivelActivos();
          const nivelesActualizados = this.nivelesActivos.data || this.nivelesActivos;
          nivelEncontrado = nivelesActualizados.find(n => Number(n.level) === nivelHijo);

          if (!nivelEncontrado) {
            this.$alertError('Error al crear el nivel automáticamente. Por favor, inténtelo de nuevo.');
            return;
          }

        } catch (error) {
          await this.listarNivelActivos();
          const nivelesActualizados = this.nivelesActivos.data || this.nivelesActivos;
          nivelEncontrado = nivelesActualizados.find(n => Number(n.level) === nivelHijo);

          if (!nivelEncontrado) {
            var errorMsg = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : (error.message || 'Error desconocido');
            this.$alertError('Error al crear el nivel: ' + errorMsg);
            return;
          }
        }
      }

      await this.listLocationsActive();

      await this.getCountriesByCompany();

      const parentHierarchy = this.buildLocationHierarchy(ubicacion);

      this.setModuleCreated('childLocation');
      this.resetSelectedUbicacion();

      this.setSelectedUbicacion({
        id: null,
        slq_locations_level_id: nivelEncontrado.id,
        slq_company_id: this.$route.params.id,
        slq_location_id: ubicacion.id,
        parent: true,
        active: 1,
        description: '',
        // Información adicional para el modal
        _isChildLocation: true,
        _parentHierarchy: parentHierarchy,
        _parentName: ubicacion.label,
        _levelNumber: nivelHijo,
        _levelName: nivelEncontrado.description
      });

      this.setModal(true);
      this.setPaso(0);
    },

    // Construir la jerarquía lineal de una ubicación
    buildLocationHierarchy(ubicacion) {
      const findPath = (tree, targetId, path = []) => {
        for (const node of tree) {
          if (node.id === targetId) {
            return [...path, node.label];
          }
          if (node.children && node.children.length > 0) {
            const result = findPath(node.children, targetId, [...path, node.label]);
            if (result) return result;
          }
        }
        return null;
      };

      const path = findPath(this.arbolUbicaciones, ubicacion.id);
      return path ? path.join(' > ') : ubicacion.label;
    },

    async createRootLocation() {
      this.setModuleCreated('locations');
      this.resetSelectedUbicacion();

      await this.getCountriesByCompany();

      const niveles = this.nivelesActivos.data || this.nivelesActivos;
      var nivel1 = null;
      if (niveles && niveles.length > 0) {
        nivel1 = niveles.find(function(n) { return Number(n.level) === 1; });
      }

      if (!nivel1) {
        try {
          await this.crearNivelAutomatico({
            level: 1,
            description: 'Nivel 1',
            slq_company_id: this.$route.params.id,
            active: true,
            color: '#FFFFFF'
          });
          await this.listarNivelActivos();
          var nivelesActualizados = this.nivelesActivos.data || this.nivelesActivos;
          nivel1 = nivelesActualizados.find(function(n) { return Number(n.level) === 1; });

          if (nivel1) {
          }
        } catch (error) {
          await this.listarNivelActivos();
          var nivelesReload = this.nivelesActivos.data || this.nivelesActivos;
          nivel1 = nivelesReload.find(function(n) { return Number(n.level) === 1; });
        }
      }

      // Establecer el nivel 1 en la ubicación
      if (nivel1) {
        this.setSelectedUbicacion({
          id: null,
          slq_locations_level_id: nivel1.id,
          slq_company_id: this.$route.params.id,
          slq_location_id: null,
          parent: false,
          active: 1,
          description: ''
        });
      }

      this.setModal(true);
      this.setPaso(0);
    },

    // Auto-scroll durante el drag and drop
    startAutoScroll() {
      this.stopAutoScroll();

      const { speed, edgeSize, intervalMs } = this.DRAG_SCROLL_CONFIG;

      // Guardar la posición del mouse continuamente
      this._dragMouseY = -1;
      this._dragMouseMoveHandler = (e) => {
        this._dragMouseY = e.clientY;
      };
      document.addEventListener('mousemove', this._dragMouseMoveHandler);
      document.addEventListener('dragover', this._dragMouseMoveHandler);

      // Ejecutar el scroll periódicamente
      this._dragScrollInterval = setInterval(() => {
        if (this._dragMouseY < 0) return;

        const windowHeight = window.innerHeight;
        const currentScrollTop = window.scrollY || document.documentElement.scrollTop;

        // Determinar zona activa del mouse
        const inTopZone = this._dragMouseY < edgeSize;
        const inBottomZone = this._dragMouseY > windowHeight - edgeSize;

        if (inTopZone && currentScrollTop > 0) {
          window.scrollBy(0, -speed);
        } else if (inBottomZone) {
          window.scrollBy(0, speed);
        }
      }, intervalMs);
    },

    stopAutoScroll() {
      if (this._dragScrollInterval) {
        clearInterval(this._dragScrollInterval);
        this._dragScrollInterval = null;
      }
      if (this._dragMouseMoveHandler) {
        document.removeEventListener('mousemove', this._dragMouseMoveHandler);
        document.removeEventListener('dragover', this._dragMouseMoveHandler);
        this._dragMouseMoveHandler = null;
      }
      this._dragMouseY = -1;
    },

    // Determina si un nodo puede ser arrastrado
    allowDrag(draggingNode) {
      return draggingNode.data.active === 1 || draggingNode.data.active === true;
    },

    // Determina si un nodo puede ser soltado en una ubicación
    allowDrop(draggingNode, dropNode, type) {
      return true;
    },

    // Valida recursivamente los niveles de los hijos
    validateChildLevels(ubicacion, nivelBase) {
      return true;
    },

    /**
     * Busca un nivel por su número en el array de niveles
     * @param {number} levelNumber - Número del nivel a buscar
     * @returns {Object|null} - Objeto del nivel o null si no existe
     */
    findLevelByNumber(levelNumber) {
      return this.levelsArray.find(function(n) {
        return Number(n.level) === levelNumber;
      }) || null;
    },

    /**
     * Asegura que un nivel exista, creándolo si es necesario
     * @param {number} levelNumber - Número del nivel requerido
     * @returns {Object|null} - Objeto del nivel o null si falla
     */
    async ensureLevelExists(levelNumber) {
      var nivelObj = this.findLevelByNumber(levelNumber);

      if (nivelObj) {
        return nivelObj;
      }

      try {
        await this.crearNivelAutomatico({
          level: levelNumber,
          description: 'Nivel ' + levelNumber,
          slq_company_id: this.$route.params.id,
          active: true,
          color: '#FFFFFF'
        });

        await this.listarNivelActivos();
        nivelObj = this.findLevelByNumber(levelNumber);

        return nivelObj;
      } catch (error) {
        await this.listarNivelActivos();
        nivelObj = this.findLevelByNumber(levelNumber);

        if (!nivelObj) {
          var errorMsg = (error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : (error.message || 'Error desconocido');
          this.$alertError('Error al crear el nivel: ' + errorMsg);
        }

        return nivelObj;
      }
    },

    /**
     * Determina el país a usar al mover una ubicación
     * @param {Object} draggingNode - Nodo que se está arrastrando
     * @param {Object} dropNode - Nodo destino
     * @param {boolean} isInner - Si se está soltando dentro del nodo
     * @returns {number|null} - ID del país o null
     */
    determineCountryForMove(draggingNode, dropNode, isInner) {
      var companyCountryId = draggingNode.data.company_country_id;

      if (!companyCountryId) {
        if (isInner) {
          companyCountryId = dropNode.data.company_country_id || null;
        } else if (dropNode.parent && dropNode.parent.data) {
          companyCountryId = dropNode.parent.data.company_country_id || null;
        }
      }

      return companyCountryId;
    },

    /**
     * Construye el mensaje de confirmación para mover ubicación
     * @param {string} origenNombre - Nombre de la ubicación origen
     * @param {Object} dropNode - Nodo destino
     * @param {boolean} isInner - Si se está soltando dentro del nodo
     * @param {number} newLevel - Nuevo nivel
     * @returns {string} - Mensaje de confirmación
     */
    buildMoveConfirmationMessage(origenNombre, dropNode, isInner) {
      var mensaje;

      if (isInner) {
        mensaje = '¿Está seguro de mover "' + origenNombre + '" dentro de "' + dropNode.data.label + '"?';
      } else if (dropNode.parent && dropNode.parent.data && dropNode.parent.data.label) {
        mensaje = '¿Está seguro de mover "' + origenNombre + '" dentro de "' + dropNode.parent.data.label + '"?';
      } else {
        mensaje = '¿Está seguro de convertir "' + origenNombre + '" en una ubicación de primer nivel?';
      }

      return mensaje;
    },

    // Maneja el evento de drop exitoso
    async handleDrop(draggingNode, dropNode, dropType) {
      const isInner = dropType === 'inner';
      const newParentId = isInner ? dropNode.data.id : dropNode.data.slq_location_id;
      const niveles = this.nivelesActivos.data || this.nivelesActivos;
      const dropNodeNivel = niveles.find(n => n.id === dropNode.data.slq_locations_level_id);
      const dropNodeLevel = dropNodeNivel ? Number(dropNodeNivel.level) : 1;
      const newLevel = isInner ? dropNodeLevel + 1 : dropNodeLevel;

      const origenNombre = draggingNode.data.label;
      const mensajeConfirmacion = this.buildMoveConfirmationMessage(origenNombre, dropNode, isInner);

      var self = this;

      this.$alertConfirmation({
        icon: 'question',
        title: 'Confirmar movimiento',
        text: mensajeConfirmacion,
        showConfirmButton: true,
        showCancelButton: true,
        titleBtnConfirm: 'Sí, mover',
        titleBtnCancel: 'Cancelar',
        onConfirm: async function() {
          try {
            var nivelObj = await self.ensureLevelExists(newLevel);

            if (!nivelObj) {
              await self.arbolUbicacionesEmpresa();
              return;
            }

            var companyCountryId = self.determineCountryForMove(draggingNode, dropNode, isInner);

            await self.moveLocation({
              id: draggingNode.data.id,
              slq_location_id: newParentId,
              slq_locations_level_id: nivelObj.id,
              description: draggingNode.data.label,
              slq_company_id: self.$route.params.id,
              company_country_id: companyCountryId
            });

            self.$alertSuccess('Ubicación movida correctamente');
          } catch (error) {
            self.$alertError('Error al mover la ubicación');
          }
          await self.arbolUbicacionesEmpresa();
        },
        onCancel: function() { self.arbolUbicacionesEmpresa(); },
        onDismiss: function() { self.arbolUbicacionesEmpresa(); }
      });
    },

    limpiarFiltro() {
      this.filterText = "";
    },
    focusUpdateInput() {
      setTimeout(() => {
        if (this.$refs.descripcionUpdateInput) {
          this.$refs.descripcionUpdateInput.focus();
        }
      }, 300);
    },
    async editarUbicacion(ubicacion) {
      this.resetSelectedUbicacion();
      this.setCountriesWithEnterprises([]);
      this.setEnterprises([]);
      this.setGroups([]);
      this.setBusinesses([]);
      this.setSubBusinesses([]);
      this.country_id = null;
      this.enterprise_id = null;
      this.group_id = null;
      this.business_id = null;

      if (!ubicacion.description && ubicacion.label) {
        ubicacion.description = ubicacion.label;
      }

      // Normalizar el objeto para edición desde el árbol
      if (ubicacion.slq_location_id && !ubicacion.parent_location) {
        const parentObj = this.locationsActive.find(item => item.id === ubicacion.slq_location_id);
        if (parentObj) {
          ubicacion.parent_location = parentObj;
        }
      }
      if (ubicacion.parent_location) {
        ubicacion.parent = true;
      } else {
        ubicacion.parent = false;
      }

      // Normalizar company_country_id si existe company_country
      if (ubicacion.company_country && !ubicacion.company_country_id) {
        ubicacion.company_country_id = ubicacion.company_country.id;
      }
      await this.listarNivelActivos();
      await this.listLocationsActive();

      await this.getCountriesByCompany();

      this.setSelectedUbicacion(ubicacion);
      this.establecerModalUbicaciones(true);
      this.validateLevel();
      if (this.selectedUbicacion.slq_business_sub_business_id) {
        this.country_id = this.selectedUbicacion.business_sub_business.business.group.enterprise.slq_country_id;
        this.enterprise_id = this.selectedUbicacion.business_sub_business.business.group.slq_enterprise_id;
        this.group_id = this.selectedUbicacion.business_sub_business.business.slq_group_id;
        this.business_id = this.selectedUbicacion.business_sub_business.slq_business_id;
        await this.getCountriesToCompanyId(this.$route.params.id);
        await this.getCountryByIdAndCompanyId({
          country_id: this.selectedUbicacion.business_sub_business.business.group
            .enterprise.slq_country_id,
          company_id: this.$route.params.id,
        });
      }
    },
    async validateFormUpdateLocation() {
      await this.$validator.validateAll("updateLocation").then(async (validado) => {
        if (validado) {
          await this.updateUbicacion();
          this.resetSelectedUbicacion();
          this.establecerModalUbicaciones(false);
        }
      });
    },
    async cancel() {
      this.resetSelectedUbicacion();
      this.establecerModalUbicaciones(false);
      this.level = null;
      this.locations = [];
      this.disabled = false;
      this.levelSelected = { level: null, id: null };
    },

    async getCountriesByCompany() {
      this.setCountriesOfCompany([]);
      const payload = {
        companyId: this.$route.params.id,
        page: 0,
        pagination: 0,
        status: 1
      };
      await this.loadCountriesByCompanyId(payload);
    },
    validateLevel() {
      if (!this.selectedUbicacion || !this.selectedUbicacion.slq_locations_level_id) {
        return;
      }
      let locationParent = null;
      this.nivelesActivos.data.forEach((element) => {
        if (element.id === this.selectedUbicacion.slq_locations_level_id) {
          this.levelSelected.id = element.id;
          this.levelSelected.level = element.level;
        }
      });

      if (this.levelSelected.level > 1) {
        this.locations = this.locationsActive.filter(
          (item) => item.location_level.level === this.levelSelected.level - 1
        );

        this.selectedUbicacion.parent = true;
        this.disabled = true;

        locationParent = this.locationsActive.filter(
          (item) => item.id === this.selectedUbicacion.slq_location_id
        );

        if (
          locationParent.length > 0 &&
          locationParent[0].location_level &&
          locationParent[0].location_level.level + 1 !== this.levelSelected.level
        ) {
          this.selectedUbicacion.slq_location_id = null;
        }
      } else {
        this.locations = this.locationsActive;
        this.selectedUbicacion.parent = false;
      }
    },
    ...mapActions("location", [
     "inactiveLocation",
     "listLocationsActive",
     "listarNivelActivos",
     "updateUbicacion",
     "arbolUbicacionesEmpresa",
     "deleteUbicacion",
     "moveLocation",
     "crearNivelAutomatico",
    ]),
    ...mapActions("countries", ["getCountriesToCompanyId", "getCountryByIdAndCompanyId"]),
    ...mapActions("enterprises", ["getEnterpriseByIdAndCompanyId"]),
    ...mapActions("groups", ["getGroupByIdAndCompanyId"]),
    ...mapActions("businesses", ["getBusinessByIdAndCompanyId"]),
    ...mapActions('configurableVariables', {
      loadCountriesByCompanyId: 'loadConfigurableVariables'
    }),
    ...mapMutations("location", [
      "establecerModalUbicaciones",
      "setSelectedUbicacion",
      "resetSelectedUbicacion",
      "setCountriesWithEnterprises",
      "setEnterprises",
      "setGroups",
      "setBusinesses",
      "setSubBusinesses",
      "setModal",
      "setPaso",
      "setModuleCreated",
      "setFiltroActive",
    ]),
    ...mapMutations("countries", ["setCountriesWithEnterprises"]),
    ...mapMutations("enterprises", ["setEnterprises"]),
    ...mapMutations("groups", ["setGroups"]),
    ...mapMutations("businesses", ["setBusinesses", "setSubBusinesses"]),
    ...mapMutations('configurableVariables', {
      setCountriesOfCompany: 'setConfigurableVariables'
    }),
      },
  computed: {
    ...mapState("location", ["arbolUbicaciones", "nivelesActivos", "locationsActive", "modal_ubicaciones", "selectedUbicacion"]),
    ...mapState("countries", ["countriesWithEnterprises"]),
    ...mapState("enterprises", ["enterprises"]),
    ...mapState("groups", ["groups"]),
    ...mapState("businesses", ["businesses", "subBusinesses"]),
    // Estados del modulo Países de la empresa (variables configurable)
    ...mapState('configurableVariables', {
      countriesCompany: 'configurableVariables'
    }),

    /**
     * Obtener el país seleccionado de la lista de países de la empresa
     */
    selectedCountry() {
        if (!this.countriesCompany || !this.selectedUbicacion.company_country_id) return null;
        return this.validCountriesCompany.find(c => c.id === this.selectedUbicacion.company_country_id);
    },
    validCountriesCompany() {
        if (!Array.isArray(this.countriesCompany)) return [];
        return this.countriesCompany.filter(c => c.country && c.country.name && c.country.code);
    },
    levelsArray() {
      if (!this.nivelesActivos) return [];
      return this.nivelesActivos.data || (Array.isArray(this.nivelesActivos) ? this.nivelesActivos : []);
    },
  },
};
</script>

<style scoped>
.custom-tree-node {
  font-weight: bold;
  text-transform: uppercase;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  padding-right: 8px;
}
.inactive-node {
  opacity: 0.6;
  filter: grayscale(1);
  color: #717375 !important;
}
.inactive-node i.fa {
  color: inherit !important;
}
.fa-trash {
  font-size: 20px;
}
.fa-edit-tree {
  font-size: 18px;
}
.el-tree-node__expand-icon {
  cursor: pointer;
  color: #097b83;
  height: 30px;
  font-size: 25px;
  -webkit-transform: rotate(0);
  transform: rotate(0);
  -webkit-transition: -webkit-transform 0.3s ease-in-out;
  transition: -webkit-transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
}

.action-buttons {
  margin-left: 10px;
}

.el-tree-node.is-drop-inner > .el-tree-node__content {
  background-color: #d4edda !important;
  border: 2px dashed #28a745 !important;
  border-radius: 4px;
}

.el-tree-node.is-dragging > .el-tree-node__content {
  opacity: 0.5;
  background-color: #e3f2fd !important;
  border: 2px solid #2196f3 !important;
  border-radius: 4px;
}

.el-tree-node.is-dragging .custom-tree-node {
  opacity: 0.7;
}

.el-tree__drop-indicator {
  background-color: #2196f3 !important;
  height: 3px !important;
}
</style>

<!-- Estilos globales para drag and drop -->
<style>
.el-tree-node.is-dragging {
  opacity: 0.4 !important;
}

.el-tree-node.is-dragging > .el-tree-node__content {
  background-color: #bbdefb !important;
  border: 2px dashed #1976d2 !important;
  border-radius: 4px;
}

.el-tree-node.is-drop-inner > .el-tree-node__content {
  background-color: #c8e6c9 !important;
  border: 2px dashed #388e3c !important;
  border-radius: 4px;
}

.el-tree__drop-indicator {
  background-color: #1976d2 !important;
  height: 4px !important;
}

/* ========== MEJORAS VISUALES DEL ÁRBOL ========== */
.tree-country-info {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}

.tree-country-info .flag-icon {
  font-size: 0.8em;
}

.tree-country-acronym {
  font-size: 0.8em;
  font-weight: 600;
  color: #555;
}

/* Estilos para imágenes de banderas */
.flag-img-select {
  height: 15px;
}

.flag-img-option {
  height: 20px;
}

.flag-img-tree {
  height: 15px;
}

.flag-prefix-container {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 5px;
}


/* INDENTACIÓN MÁS PRONUNCIADA */
.el-tree-node__children {
  padding-left: 10px !important;
}

/* BORDE IZQUIERDO POR NIVEL */
.el-tree-node > .el-tree-node__content {
  border-left: 4px solid transparent;
  padding-left: 8px;
}

.el-tree-node:hover > .el-tree-node__content {
  border-left-color: #969696;
    background-color: rgba(131, 132, 133, 0.1);
}

.el-tree-node__content {
  transition: all 0.2s ease;
  border-radius: 4px;
  margin: 1px 0;
}

/* BOTONES DE ACCIÓN - ocultos por defecto, visibles en hover */
.action-buttons {
  opacity: 0;
  transition: opacity 0.2s ease;
  display: inline-flex;
  align-items: center;
}

.el-tree-node__content:hover .action-buttons {
  opacity: 1;
}

/* Estilo de los botones */
.action-buttons .el-button {
  padding: 2px 6px !important;
  margin-left: 2px;
}
</style>
